import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css'
import router from './router'
import HighchartsVue from 'highcharts-vue';
import store from './store'
//import './mock';

process.env.VUE_APP_MOCK_ENABLED === 'true' && require('./mock/index')
Vue.config.devtools = (process.env.VUE_APP_ENABLED_DEV_TOOL) //有這個屬性
Vue.config.productionTip = false

Vue.use(HighchartsVue)
Vue.use(VuetifyDialog, {context: {vuetify}})

new Vue(
  {
    vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
